import { Fab, Icon, Tooltip } from '@material-ui/core';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import DefaultSettings from '../settings';


/**
 * Represents a component for Workflow Items.
 * @param {Object} props - The props for the component.
 * @param {string} props.label - The label for the component.
 * @param {any} props.value - The value for the component.
 * @param {string} props.name - The name for the component.
 * @param {Function} props.handleFieldValue - The function to handle field value changes.
 * @param {Object} props.fieldValues - The field values object.
 * @param {boolean} props.disabled - Indicates if the component is disabled.
 * @param {Array} props.flowIds - The flow IDs array.
 * @param {boolean} props.saveUsers - Indicates if users should be saved.
 * @param {Object} props.otherProps - Other additional props for the component.
 * @returns {JSX.Element} The rendered WorkflowItems component.
 */
function WorkflowItems({ label, value, name, handleFieldValue, fieldValues, disabled, flowIds, saveUsers = false, ...otherProps }) {
    const [currentObj, setCurrentObj] = React.useState({});
    const params = useParams();
    const selectedIds = useSelector(state => state.header && state.header.selectedGridRows);

    useEffect(() => {
        // Check if saveUsers is true and fieldValues and fieldValues['Users'] exist and value is true
        if (saveUsers === true && fieldValues && fieldValues['Users'] && value === true) {
            const CurrentlyAssignedval = fieldValues['CurrentlyAssigned'] === 'undefined' ? 'Y' : fieldValues['CurrentlyAssigned']
            const Futureworkflowval = fieldValues['Futureworkflow'] === 'undefined' ? 'Y' : fieldValues['Futureworkflow']
            let ids = selectedIds && selectedIds.length > 0 ? selectedIds.map(item => item['Workflow Id']) : []
            let status = []
            if (CurrentlyAssignedval === 'Y')
                status.push(1)
            else
                status.push(0);

            if (Futureworkflowval === 'Y')
                status.push(1)
            else
                status.push(0);
            let user = fieldValues['Users']
            // let group = fieldValues['ROLES']
            var newUserString = fieldValues['SwitchUserList']
            var newuser = newUserString.toString();
            // let group = 'Utility Coordinator'//fieldValues['ROLES']
            let currentlyassigned = fieldValues['CurrentlyAssigned'] === 'undefined' ? 'Y' : fieldValues['CurrentlyAssigned']
            let futureworkflow = fieldValues['Futureworkflow'] === 'undefined' ? 'Y' : fieldValues['Futureworkflow']
            if (typeof window.workflowObj !== "undefined") {
                // Call the updateassignments function of window.workflowObj.data
                window.workflowObj.data.updateassignments(
                    ids, user, newuser, currentlyassigned, futureworkflow,
                    function (res) {
                        if (res && res.msg) {
                            if (DefaultSettings.getAlert() != null)
                                DefaultSettings.getAlert().show("The records have been successfully assigned to the selected user.", 'success');
                        }
                    })
            }

        }
        else {
            // Check if saveUsers is false and fieldValues and fieldValues['Users'] exist and there are changes in fieldValues
            if (saveUsers === false && (fieldValues && fieldValues['Users'] && (fieldValues['Users'] !== currentObj.Users ||
                (fieldValues['CurrentlyAssigned'] && fieldValues['CurrentlyAssigned'] !== currentObj.CurrentlyAssigned) ||
                (fieldValues['Futureworkflow'] && fieldValues['Futureworkflow'] !== currentObj.Futureworkflow))
                // && fieldValues['Future'] !== 'undefined'
            )) {
                const CurrentlyAssignedval = fieldValues['CurrentlyAssigned'] === 'undefined' ? 'Y' : fieldValues['CurrentlyAssigned']
                const Futureworkflowval = fieldValues['Futureworkflow'] === 'undefined' ? 'Y' : fieldValues['Futureworkflow']
                let status = []
                if (CurrentlyAssignedval === 'Y')
                    status.push(1)
                else
                    status.push(0);

                if (Futureworkflowval === 'Y')
                    status.push(1)
                else
                    status.push(0);
                let user = fieldValues['Users']
                let group = fieldValues['ROLES']
                // let group = 'Utility Coordinator'//fieldValues['ROLES']
                let currentlyassigned = fieldValues['CurrentlyAssigned'] === 'undefined' ? 'Y' : fieldValues['CurrentlyAssigned']
                let futureworkflow = fieldValues['Futureworkflow'] === 'undefined' ? 'Y' : fieldValues['Futureworkflow']
                if (typeof window.workflowObj !== "undefined") {
                    // Call the findassignments function of window.workflowObj.data
                    window.workflowObj.data.findassignments(
                        user, group, currentlyassigned, futureworkflow,
                        function (res) {
                            if (res && res.length > 0) {
                                var flowid = []
                                res.map(item => {
                                    if (item.flowid) {
                                        let id = "'" + item.flowid + "'"
                                        flowid.push(id)
                                    }
                                })
                                const flowIds = res.map(item => String(item.flowid));
                                setCurrentObj(fieldValues);
                                // if (flowid.length > 0) {
                                //     handleFieldValue({ target: { value: flowid, name: name, checked: false } });
                                //     // let url = getEnvVariable('Application') + `/api/Application/All/APPLICATIONS/WorkflowIds/${params.Id}`
                                //     // PostData(url, flowIds).then(resp => {
                                //     //     handleFieldValue({ target: { value: resp, name: name, checked: false } })
                                //     // })
                                // }
                                handleFieldValue({ target: { value: flowIds, name: name, checked: false } })
                            }
                        })
                }

            }
        }
        // Your useEffect logic here
        // This code will run when the component mounts
        return () => {
            // Cleanup logic here
            // This code will run when the component unmounts   
            setCurrentObj({})

        };
    }, [fieldValues, fieldValues['Users']]);

    return (
        < >
            {saveUsers === false && <Tooltip title="Flow Ids" aria-label="Set Flow Ids">
                <Icon size="small" disabled={disabled} color="primary">
                    <AutorenewRoundedIcon fontsize='small' style={{ marginBottom: '10px' }} />
                </Icon>
            </Tooltip>}
        </>
    );
}

export default WorkflowItems;
